import { Link } from 'react-router-dom';
import { Manga } from '@/mocks/manga';

interface MangaCardProps {
  manga: Manga;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/manga/${manga.id}`}
      className="group block rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300 overflow-hidden"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={manga.cover}
          alt={`${manga.title} - 亲亲漫画网`}
          title={`${manga.title} - 下拉式完整版免费阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className={`px-2 py-0.5 text-xs font-medium rounded-full ${
            manga.status === '连载中'
              ? 'bg-primary-500 text-background-50'
              : 'bg-secondary-500 text-background-50'
          }`}>
            {manga.status}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <div className="flex items-center gap-1 text-white text-xs">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-accent-400 text-xs"></i>
            </div>
            <span>{manga.rating}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
          {manga.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1.5">{manga.author}</p>
        <div className="flex items-center gap-2 mt-2">
          {manga.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs rounded-full bg-secondary-50 text-secondary-700 border border-secondary-200/50"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}